<template>
  <base-dialog v-model="show" @close="close" :loading="loading" fullscreen>
    <template v-slot:title> {{ title }} </template>
    <div class="d-flex flex-column full-height">
      <div class="d-flex py-2 flex-grow-0">
        <v-text-field
          hide-details
          label="Nhập để tìm kiếm"
          outlined
          prepend-inner-icon="mdi-magnify"
          v-model="params.search"
          dense
        ></v-text-field>
      </div>
      <div class="flex-grow-1 overflow-auto">
        <base-serve-table
          v-if="show"
          ref="table"
          :api="api"
          :headers="headers"
          v-model="selectsLayer"
          :params="params"
          :defaultParams="default_params"
          use-selected
          multi-select
        >
          <template v-slot:[`item.created_at`]="{ item }">
            <span>
              {{ item.created_at | dateTime('short') }}
            </span>
          </template>
          <template v-slot:[`item.updated_at`]="{ item }">
            <span>
              {{ item.updated_at | dateTime('short') }}
            </span>
          </template>
        </base-serve-table>
      </div>
    </div>

    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :disabled="selectsLayer.length < 1"
        :loading="loading"
        outlined
        @click="onSubmit"
      >
        Áp dụng
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { API_LAYER } from '@/src/service/api'
export default {
  props: {
    title: { type: String, default: 'Chọn lớp bản đồ' },
    wid: Number,
  },
  data: () => ({
    show: false,
    loading: false,
    default_params: {
      is_publish: true,
      with: 'workspace',
      workspace_id: 0
    },
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        trans: 'layer.belong_to_workspace',
        align: 'start',
        sortable: false,
        value: 'workspace.name',
      },
      {
        text: 'Loại',
        align: 'start',
        sortable: true,
        value: 'type',
      },
      {
        trans: 'layer.projection',
        align: 'start',
        sortable: true,
        value: 'srs',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
    ],
    params: { search: '', inactive: null },
    selectsLayer: [],
  }),
  computed: {
    api() {
      return API_LAYER
    },
  },
  created(){
    this.default_params.workspace_id = this.wid
  },
  methods: {
    open() {
      this.params = { search: '', inactive: null }
      this.selectsLayer = []
      this.show = true
    },
    close() {
      this.show = false
      this.loading = false
      this.selectsLayer = []
    },
    onSubmit() {
      this.$emit('submit', this.selectsLayer)
      this.close()
    },
  },
}
</script>

<style scoped></style>
